import {
  ACHPaymentInfoDTO,
  ACHPaymentInfoSchema,
} from 'shared/modules/carrier-profile/data/CarrierProfileDTO';
import { useState } from 'react';
import { useSendACHPaymentInfoVerificationCode } from 'shared/modules/carrier-profile/data/CarrierProfileAPI';
import { useSnackbarStack } from '@superdispatch/ui';
import { useInitialValues } from 'shared/form/AppFormik';
import { useFormikEnhanced } from '@superdispatch/forms';
import { APIResponse } from 'shared/api/CarrierAPIClient';

export function useACHPaymentInfoForm({
  paymentInfo,
  onSuccess,
}: {
  paymentInfo?: ACHPaymentInfoDTO;
  onSuccess: () => void;
}) {
  const [updatedPaymentInfo, setUpdatedPaymentInfo] =
    useState<ACHPaymentInfoDTO>();
  const { mutateAsync: sendCode } = useSendACHPaymentInfoVerificationCode();
  const { addSnackbar } = useSnackbarStack();
  const initialValues = useInitialValues(ACHPaymentInfoSchema, paymentInfo);

  const formik = useFormikEnhanced<ACHPaymentInfoDTO, APIResponse>({
    initialValues,
    validationSchema: ACHPaymentInfoSchema,
    onSubmit: (values) => {
      setUpdatedPaymentInfo(values);
      return sendCode('email');
    },
    onSubmitSuccess: () => {
      onSuccess();
    },
    onSubmitFailure: ({ message }) =>
      addSnackbar(`Failed to update ACH payment info: ${message}`, {
        variant: 'error',
      }),
  });

  return {
    formik,
    updatedPaymentInfo,
    setUpdatedPaymentInfo,
  };
}
